import { render, staticRenderFns } from "./SectionWrap.vue?vue&type=template&id=c7cf17ce&scoped=true&"
import script from "./SectionWrap.vue?vue&type=script&lang=js&"
export * from "./SectionWrap.vue?vue&type=script&lang=js&"
import style0 from "./SectionWrap.vue?vue&type=style&index=0&id=c7cf17ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cf17ce",
  null
  
)

export default component.exports